<template>
    <template v-if="users && users.data.length > 0">
        <teleport to="#warnings">
            <alert-block
                v-if="false"
                :color="'orange-500'"
                fill
            >
                <template #title>
                    Maximaal aantal gebruikers bijna bereikt. Voeg voor slechts €10 een extra gebruiker toe.
                </template>
            </alert-block>
        </teleport>

        <flex-container>
            <flex-container>
                <flex-container
                    :size="7"
                    align-items="center"
                >
                    <text-heading>
                        <span style="margin-bottom: 3px">Medewerkers</span>
                    </text-heading>
                    <chip-informative v-if="false" :color="'primary'">
                        {{ users.data.length }} / 5
                    </chip-informative>
                    <alert-block v-if="false" :color="'blue-500'">
                        <template #title>
                            Elke 24 uur voeren we automatisch een update uit van nieuwe medewerkers vanuit Realworks.
                        </template>
                    </alert-block>
                </flex-container>
                <flex-container :size="3" justify-content="flex-end">
                    <add-user-button @click="$router.push({ name: 'user-create' })" />
                </flex-container>
            </flex-container>
            <card-normal without-padding :with-overflow="false">
                <user-list :users="users.data" />
            </card-normal>

            <flex-container justify-content="center">
                <flex-container :size="3" padding="xl">
                    <person-check-icon />
                </flex-container>
            </flex-container>
        </flex-container>
    </template>

    <template v-else>
        <user-collection-empty-message />
    </template>

    <router-view />
</template>

<script setup lang="ts">
    import PersonCheckIcon from '@/assets/icons/undraw/person_check.svg?component';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import { User, UserType } from '@keyvue/one-api-client';
    import useEventBus from '@/services/eventbus/composables/useEventBus';
    import UserDeletedEvent from '@/company/user/events/UserDeletedEvent';
    import { ref } from 'vue';
    import AddUserButton from '@/company/user/components/AddUserButton.vue';
    import UserCollectionEmptyMessage from '@/company/user/components/UserCollectionEmptyMessage.vue';
    import UserList from '@/company/user/components/UserList.vue';

    const { client, currentCompany } = useClient();
    const eventBus = useEventBus();

    const users = ref();

    async function loadUsers() {
        users.value = await client.getSubResources(currentCompany.value, User, 'users', {
            type: UserType.DEFAULT.value,
            active: true,
        });
    }

    await loadUsers();

    eventBus.subscribe(UserDeletedEvent, loadUsers);
</script>
